import { render, staticRenderFns } from "./virtualCardDetail.vue?vue&type=template&id=41a88bda&"
import script from "./virtualCardDetail.vue?vue&type=script&lang=js&"
export * from "./virtualCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./virtualCardDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports